import React from 'react';
import ProjectCard from '../molecules/ProjectCard';

const PreFooter = () => {
    return (
        <div className="h-[60vh] relative overflow-hidden">
            <ProjectCard index={0} project={{ image: "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2069&auto=format&fit=crop", title: "", client: "", category: "" }} />
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <h2 className="font-migra text-6xl md:text-9xl text-white mix-blend-overlay opacity-50">Legacy.</h2>
            </div>
        </div>
    );
};

export default PreFooter;
